import React, { useEffect, useState } from 'react';
import { useDropzone } from 'react-dropzone';
import { Stack, IconButton, Typography, useTheme } from '@mui/material';

import CameraAltIcon from '@mui/icons-material/CameraAlt';
import pdfIcon from '../../assets/images/pdfIcon.png';
import FileViewer from '../FileViewer/FileViewer';

function ProfileImageUploader({ handleFile, inputId, url, placeholder, helpTextShow = false, showFileName = true, disableDownload = true, width, height, iconViewHeight, iconMargin, iconSize }) {
  const [error, setError] = useState('');

  const theme = useTheme();

  const [file, setFile] = useState(null);
  const [fileType, setFileType] = useState(null);
  const [filePreview, setFilePreview] = useState(null);
  const [openModal, setOpenModal] = useState(false);

  useEffect(() => {
    if (url && url.type) {
      const fileType = url.type.startsWith('image') ? 'image' : 'pdf';
      if (fileType === 'image') {
        const image = new Image();
        image.src = URL.createObjectURL(url);
        image.addEventListener('load', () => {
          let objUrl = URL.createObjectURL(url);
          setFilePreview(objUrl);
          setFileType(fileType);
        });
      } else {
        setFilePreview(pdfIcon);
        setFileType(fileType);
      }
    } else {
      if (url) {
        const type = url.split('.').pop();
        if (type === 'jpg' || type === 'png' || type === 'jpeg' || type === 'webp' || type === 'svg') {
          setFilePreview(url);
        } else {
          setFilePreview(pdfIcon);
        }
      } else {
        setFilePreview(null);
      }
    }
  }, [url]);

  const onDrop = async (files) => {
    if (!files || files.length === 0) {
      return;
    }
    if (files[0].size > 1000000) {
      handleFile(null);
      setError('File size should be less than or equal to  1MB');
      setFile(null);
      setFilePreview(null);
      return;
    }
    const fileType = files[0].type.startsWith('image') ? 'image' : 'pdf';
    if (fileType === 'image') {
      const image = new Image();
      image.src = URL.createObjectURL(files[0]);
      image.addEventListener('load', () => {
        handleFile(files[0]);
        setFile(files[0]);
        let objUrl = URL.createObjectURL(files[0]);
        setFilePreview(objUrl);
        setFileType(fileType);
        setError(false);
      });
    } else {
      handleFile(files[0]);
      setFile(files[0]);
      setFilePreview(pdfIcon);
      setError(false);
      setFileType(fileType);
    }
  };

  const onCancelFile = () => {
    handleFile(null);
    setFilePreview(null);
    setError(false);
    setFile(null);
    setFileType(null);
  };

  const { getRootProps, getInputProps, isDragActive, isDragReject } = useDropzone({
    accept: {
      'image/*': ['.jpeg', '.png', '.webp', '.jpg'],
    },
    onDrop,
    maxFiles: 1,
  });

  const handleFileOpener = () => {
    if (file) {
      if (fileType === 'image') {
        setOpenModal(true);
      } else {
        const blob = new Blob([file], { type: file.type });
        const dataUrl = window.URL.createObjectURL(blob);
        window.open(dataUrl, '_blank', 'noreferrer');
      }
    } else {
      const type = url.split('.').pop();
      if (type === 'jpg' || type === 'png' || type === 'jpeg' || type === 'webp') {
        setOpenModal(true);
      } else {
        window.open(url, '_blank', 'noreferrer');
      }
    }
  };

  return (
    <Stack
      alignItems="center"
      //   className="w-full"
    >
      <Stack style={{ width: width ? width : '120px', height: height ? height : '120px', borderRadius: '50%', backgroundColor: '#F1F1F1', overflow: 'hidden' }}>
        {!(file || url) && (
          <div
            className="dropZone"
            style={{ cursor: 'pointer', width: '100%', height: '100%', position: 'relative' }}
            {...getRootProps({ className: 'dropzone' })}
          >
            <Stack
              alignItems="center"
              className="dropZone !px-[16px]"
              justifyContent={'space-between'}
              direction={'column'}
            >
              <input
                id={inputId}
                {...getInputProps()}
              />
              <Typography
                className="fs-14 ff-Roboto fw-medium"
                color={theme.palette.primary.text}
              >
                {placeholder}
              </Typography>
            </Stack>

            <Stack style={{ backgroundColor: '#14285A57', alignItems: 'center', justifyContent: 'center', height: iconViewHeight ? iconViewHeight : '32px', position: 'absolute', bottom: 0, left: 0, width: '100%' }}>
              {' '}
              <CameraAltIcon style={{ color: '#FFFFFF', width: iconSize ? iconSize : '16px', height: iconSize ? iconSize : '16px' }} />
            </Stack>
          </div>
        )}

        {Boolean(error) && !file && (
          <div
            className="dropZone"
            style={{ cursor: 'pointer', width: '100%', height: '100%', position: 'relative' }}
            {...getRootProps({ className: 'dropzone' })}
          >
            <Stack
              alignItems="center"
              className="dropZone !px-[16px]"
              justifyContent={'space-between'}
              direction={'column'}
            >
              <input
                id={inputId}
                {...getInputProps()}
              />
              <Typography
                className="fs-14 ff-Roboto fw-medium"
                color={theme.palette.primary.text}
              >
                {placeholder}
              </Typography>
            </Stack>

            <Stack style={{ backgroundColor: '#14285A57', alignItems: 'center', justifyContent: 'center', height: iconViewHeight ? iconViewHeight : '32px', position: 'absolute', bottom: 0, left: 0, width: '100%' }}>
              {' '}
              <CameraAltIcon style={{ color: '#FFFFFF', width: iconSize ? iconSize : '16px', height: iconSize ? iconSize : '16px' }} />
            </Stack>
          </div>
        )}

        {!Boolean(error) && (file || url) && (
          <Stack
            // flexDirection="row"
            // alignItems="center"
            style={{ position: 'relative', cursor: 'pointer', width: '100%', height: '100%' }}
            justifyContent="center"
            {...getRootProps({ className: 'dropzone' })}
          >
            <img
              alt=""
              src={filePreview || url}
              style={{ width: '100%', height: '100%', objectFit: 'cover' }}
            />
            <input
              id={inputId}
              {...getInputProps()}
            />
            <Stack style={{ backgroundColor: '#14285A57', alignItems: 'center', justifyContent: 'center', height: iconViewHeight ? iconViewHeight : '32px', position: 'absolute', bottom: 0, left: 0, width: '100%' }}>
              {' '}
              <CameraAltIcon style={{ color: '#FFFFFF', width: iconSize ? iconSize : '16px', height: iconSize ? iconSize : '16px' }} />
            </Stack>
          </Stack>
        )}
      </Stack>
      {Boolean(error) && (
        <Typography
          className="fs-10 ff-Roboto fw-regular"
          color={theme.palette.error.main}
        >
          {error}
        </Typography>
      )}
      {helpTextShow && (
        <Typography
          className="fs-10 ff-Roboto fw-regular !mt-2.5"
          color={'#666666'}
        >
          (Maximum file size 3mb or below. Supported format Jpg, Jpeg, Png, Webp, Pdf)
        </Typography>
      )}
      {openModal && (
        <FileViewer
          file={filePreview || url}
          closeModal={() => setOpenModal(false)}
          open={openModal}
          disableDownload={disableDownload}
        />
      )}
    </Stack>
  );
}

export default ProfileImageUploader;
